module.exports = __webpack_public_path__ + "static/media/browserify-icon.747b3fec.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/browserify-icon.svg
 ** module id = 214
 ** module chunks = 0
 **/